import {ApiClient} from '@hconnect/apiclient'
import {QueryTimeRange} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'

import {MyTasksSummary} from '../types'

const QueryKey = 'tasks'

export const useMyTasksSummary = (
  plantId: string,
  dateRange: QueryTimeRange,
  options?: Omit<UseQueryOptions<MyTasksSummary, AxiosError>, 'queryKey' | 'queryFn'> & {
    onError?: (error: AxiosError) => void
  }
) => {
  const query = useQuery<MyTasksSummary, AxiosError>({
    queryKey: [QueryKey, dateRange, plantId],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<MyTasksSummary>(
        `/tasks/${plantId}/summary/my-tasks`,
        {params: {from: dateRange.startDate, to: dateRange.endDate}, signal}
      )

      return response.data
    },
    ...options
  })

  const onError = options?.onError

  useEffect(() => {
    if (query.error) {
      onError?.(query.error)
    }
  }, [query.error, onError])

  return query
}
